import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Obfuscate from "react-obfuscate";
import { prodHome, prodFacebook, prodLinkedin, prodSupportEmail, prodSupportPhone } from "./AppConfig";

import { faFacebook } from '@fortawesome/free-brands-svg-icons'
import { faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { faHome } from '@fortawesome/free-solid-svg-icons'
import { faEnvelopeOpenText } from '@fortawesome/free-solid-svg-icons'
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons'

const useStyles = makeStyles({
  root: {
    textAlign: "center",
    display: "block",
    marginLeft: "auto",
    marginRight: "auto"
  },
});

export default function SimpleBottomNavigation() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  return (
    <BottomNavigation
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue);
      }}
      showLabels
      className={classes.root}
    >
    <BottomNavigationAction
      label={<Obfuscate
        tel={prodSupportPhone}
      />}
      showLabel={true}
      icon={<FontAwesomeIcon icon={faPhoneSquare} />} />
      <a href={prodHome}> <BottomNavigationAction label="Home" showLabel={true} icon={<FontAwesomeIcon icon={faHome} />} /> </a>
      <a href={prodFacebook}> <BottomNavigationAction label="Facebook" showLabel={true} icon={<FontAwesomeIcon icon={faFacebook} />} /> </a>
      <a href={prodLinkedin}> <BottomNavigationAction label="LinkedIn" showLabel={true} icon={<FontAwesomeIcon icon={faLinkedin} />} /> </a>
      <BottomNavigationAction
        label={<Obfuscate
          linkText="email"
          email={prodSupportEmail}
        />}
        showLabel={true}
        icon={<FontAwesomeIcon icon={faEnvelopeOpenText} />} />
    </BottomNavigation>
  );
}
